import CustomPage from 'CustomModules/CustomPackage/pages/CustomPage/CustomPage'

export const Routes = [
  {
    path: '/custom',
    name: 'Custom Page',
    component: CustomPage
  }
]



// WEBPACK FOOTER //
// ./src/customization/CustomPackage/routes.js